
import {
  defineComponent,
} from 'vue';
import BottomPopUpItem from '@/components/BottomPopUp/BottomPopUpItem.vue';
import AppBottomPopUp from '@/components/BottomPopUp/AppBottomPopUp.vue';

export default defineComponent({
  emits: ['close', 'delete', 'move'],
  props: {
    hideMoveTo: { type: Boolean, default: false },
  },
  components: {
    BottomPopUpItem,
    AppBottomPopUp,
  },
  setup(props, { emit }) {
    function hidePopUp() {
      emit('close');
    }

    function deleteAll() {
      emit('delete');
    }

    function moveAll() {
      emit('move');
    }

    return {
      hidePopUp,
      deleteAll,
      moveAll,
    };
  },
});
